import { ModalModule, SvgIconModule } from '@toro/common/shared/components';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogDepositModule } from '../../dialog-deposit/dialog-deposit.module';
import { OpenAccountTransferComponent } from './open-account-transfer.component';

@NgModule({
  declarations: [
    OpenAccountTransferComponent,
  ],
  imports: [
    CommonModule,
    SvgIconModule,
    DialogDepositModule,
    ModalModule,
  ],
  exports: [OpenAccountTransferComponent],
})
export class OpenAccountTransferModule { }
